module.exports = __webpack_public_path__ + "img/momo_button_profile.dfd74630.png";